//Lets keep these in alphabetical order.
//Easier to find that way.

const APIV1 = '/api/v1';

const endpoints = {
  customer: {
    create: {},
    read: {
      one: {
        admin: {
          by: {
            customerId: () => `${APIV1}/customer/read/one/admin/by/customerId`,
          },
        },
        by: {
          userId: () => `${APIV1}/customer/read/one/by/userId`,
        },
      },
      activeUserCount: {
        by: {
          customerId: () =>
            `${APIV1}/customer/read/activeusercount/by/customerid`,
        },
      },
    },
    update: {},
    delete: {},
  },
  customerLocationGlobalLocationNumber: {
    create: {
      one: () => `${APIV1}/customerlocationgloballocationnumber/create/one`,
    },
    read: {
      many: {
        by: {
          userId: () =>
            `${APIV1}/customerlocationgloballocationnumber/read/many/by/userid`,
        },
      },
    },
    update: {
      one: () => `${APIV1}/customerlocationgloballocationnumber/update/one`,
    },
    delete: {
      one: () => `${APIV1}/customerlocationgloballocationnumber/delete/one`,
    },
  },
  customerLocation: {
    create: {
      one: () => `${APIV1}/customerlocation/create/one`,
      address: () => `${APIV1}/customerlocation/create/address`,
    },
    read: {
      one: {
        by: {
          id: () => `${APIV1}/customerlocation/read/one/by/id`,
        },
        hydrated: {
          by: {
            id: () => `${APIV1}/customerlocation/read/one/hydrated/by/id`,
          },
        },
      },
      all: {
        by: {
          userId: () => `${APIV1}/customerlocation/read/all/by/userid`,
        },
        hydrated: {
          by: {
            userId: () =>
              `${APIV1}/customerlocation/read/all/hydrated/by/userid`,
          },
        },
      },
    },
    update: {
      one: {
        address: () => `${APIV1}/customerlocation/update/one/address`,
        name: () => `${APIV1}/customerlocation/update/one/name`,
      },
      deactivate: {
        many: {
          by: {
            id: () => `${APIV1}/customerlocation/update/deactivate/many/by/id`,
          },
        },
      },
      activate: {
        one: {
          by: {
            id: () => `${APIV1}/customerlocation/update/activate/one/by/id`,
          },
        },
      },
    },
    delete: {
      one: {
        address: () => `${APIV1}/customerlocation/delete/one/address`,
      },
    },
  },
  documentException: {
    create: {
      one: {
        download: () => {
          return `${APIV1}/documentexception/create/one/download`;
        },
        status: () => {
          return `${APIV1}/documentexception/create/one/status`;
        },
      },
    },
    read: {
      count: () => {
        return `${APIV1}/documentexception/read/count`;
      },
      one: {
        by: {
          id: () => `${APIV1}/documentexception/read/one/by/id`,
        },
      },
      many: {
        by: {
          filters: () => `${APIV1}/documentException/read/many/by/filters`,
        },
      },
    },
  },
  state: {
    read: {
      all: () => `${APIV1}/state/read/all`,
    },
  },
  fastspring: {
    create: {
      cart: () => `${APIV1}/fastspring/create/cart`,
    },
    read: {
      all: {
        accounts: {
          by: {
            userId: () => `${APIV1}/fastspring/read/all/accounts/by/userid`,
          },
        },
        subscriptions: {
          by: {
            userId: () =>
              `${APIV1}/fastspring/read/all/subscriptions/by/userid`,
          },
        },
        orders: {
          by: {
            userId: () => `${APIV1}/fastspring/read/all/orders/by/userid`,
          },
        },
        products: () => `${APIV1}/fastspring/read/all/products`,
      },
    },
    update: {},
    cancel: {
      one: {
        subscription: {
          by: {
            id: () => `${APIV1}/fastspring/cancel/one/subscription/by/id`,
          },
        },
      },
    },
  },
  file: {
    read: {
      many: {
        sopAttachments: {
          by: {
            customerId: () =>
              `${APIV1}/file/read/many/sopattachments/by/customerid`,
          },
        },
      },
    },
    delete: {
      one: {
        sopAttachment: {
          by: {
            id: () => `${APIV1}/file/delete/one/sopattachment/by/id`,
          },
        },
      },
    },
    upload: {
      many: {
        sop: () => `${APIV1}/file/upload/many/sop`,
      },
      sop: () => `${APIV1}/file/upload/sop`,
    },
    download: {
      sop: () => `${APIV1}/file/download/sop`,
      sopAttachment: {
        by: {
          id: () => `${APIV1}/file/download/sopattachment/by/id`,
        },
      },
    },
  },
  illegitReport: {
    create: {
      one: () => `${APIV1}/illegitreport/create/one`,
      send: () => `${APIV1}/illegitreport/create/send`,
    },
    download: {
      one: {
        by: {
          path: (): string => `${APIV1}/illegitreport/download/one/by/path`,
        },
      },
    },
    read: {
      many: {
        by: {
          search: () => `${APIV1}/illegitreport/read/many/by/search`,
        },
      },
      count: {
        by: {
          userId: () => `${APIV1}/illegitreport/read/count/by/userid`,
        },
      },
      one: {
        by: {
          id: () => `${APIV1}/illegitreport/read/one/by/id`,
        },
      },
    },
    update: {
      one: {
        by: {
          id: () => `${APIV1}/illegitreport/update/one/by/id`,
        },
      },
    },
    delete: {},
  },
  med: {
    create: {
      many: {
        sendPedigrees: () => `${APIV1}/med/create/many/sendpedigrees`,
        amendPedigrees: () => `${APIV1}/med/create/many/amendpedigrees`,
      },
    },
    read: {
      one: {
        by: {
          id: () => `${APIV1}/med/read/one/by/id`,
          serialNumber: {
            pedigree: () => `${APIV1}/med/read/one/by/serialnumber/pedigree`,
          },
        },
      },
      many: {
        by: {
          search: () => `${APIV1}/med/read/many/by/search`,
        },
      },
    },
    update: {
      one: {
        unverifyReceipt: () => `${APIV1}/med/update/one/unverifyreceipt`,
      },
      receive: {
        many: {
          by: {
            serialNumber: () =>
              `${APIV1}/med/update/receive/many/by/serialnumber`,
            epcisMedVocabularyId: () =>
              `${APIV1}/med/update/receive/many/by/epcismedvocabularyid`,
            shippingContainerCode: () =>
              `${APIV1}/med/update/receive/many/by/shippingContainerCode`,
          },
        },
        all: {
          by: {
            documentId: () => `${APIV1}/med/update/receive/all/by/documentid`,
          },
        },
      },
    },
    delete: {
      one: {
        attachment: () => `${APIV1}/med/delete/one/attachment`,
      },
    },
  },
  order: {
    read: {
      many: {
        search: () => `${APIV1}/order/read/many/search`,
      },
      all: {
        meds: {
          by: {
            documentId: () => `${APIV1}/order/read/all/meds/by/documentid`,
          },
        },
      },
    },
  },
  outboundDocument: {
    read: {
      one: {
        by: {
          id: () => `${APIV1}/outbounddocument/read/one/by/id`,
        },
      },
      many: {
        search: () => `${APIV1}/outbounddocument/read/many/search`,
      },
    },
    update: {
      resend: {
        one: {
          by: {
            id: () => `${APIV1}/outbounddocument/update/resend/one/by/id`,
          },
        },
      },
    },
    download: {
      one: {
        by: {
          id: () => `${APIV1}/outbounddocument/download/one/by/id`,
        },
      },
    },
    parse: {
      one: {
        by: {
          id: () => `${APIV1}/outbounddocument/parse/one/by/id`,
        },
      },
    },
  },
  outboundDocumentStatus: {
    read: {
      statusCount: {
        by: {
          userId: () =>
            `${APIV1}/outbounddocumentstatus/read/statuscount/by/userid`,
        },
      },
    },
  },
  quarantine: {
    read: {
      count: () => `${APIV1}/quarantine/read/count`,
      many: {
        by: {
          customerLocationId: () =>
            `${APIV1}/quarantine/read/many/by/customerlocationid`,
          search: () => `${APIV1}/quarantine/read/many/by/search`,
        },
      },
    },
    create: {
      one: {
        status: () => `${APIV1}/quarantine/create/one/status`,
        quarantine: () => `${APIV1}/quarantine/create/one/quarantine`,
      },
    },
    update: {
      many: {
        by: {
          id: () => `${APIV1}/quarantine/update/many/by/id`,
        },
      },
    },
  },
  recall: {
    create: {
      one: {
        dismissedRecall: () => `${APIV1}/nrac/create/one/dismissedrecall`,
      },
    },
    read: {
      one: {
        by: {
          id: () => `${APIV1}/nrac/read/one/by/id`,
        },
        activeRecalledMedCount: {
          by: {
            userId: () =>
              `${APIV1}/nrac/read/one/activerecalledmedcount/by/userid`,
          },
        },
      },
      many: {
        search: () => `${APIV1}/nrac/read/many/search`,
        searchCount: () => `${APIV1}/nrac/read/many/searchcount`,
      },
      manyDismissed: {
        search: () => `${APIV1}/nrac/read/manyDismissed/search`,
        searchCount: () => `${APIV1}/nrac/read/manyDismissed/searchcount`,
      },
      all: {
        by: {
          recallCodeIds: () => `${APIV1}/nrac/read/all/by/recallcodeids`,
        },
        activeRecalls: {
          by: {
            recallId: () => `${APIV1}/nrac/read/all/activerecalls/by/recallid`,
            recallCodeIds: () =>
              `${APIV1}/nrac/read/all/activerecalls/by/recallcodeids`,
          },
        },
      },
    },
    update: {
      one: {
        toggleDismissedRecall: () =>
          `${APIV1}/nrac/update/one/toggledismissedrecall`,
      },
    },
    download: {
      one: {
        recallDocument: {
          by: {
            id: () => `${APIV1}/nrac/download/one/recalldocument/by/id`,
          },
        },
      },
    },
  },
  settings: {
    create: {
      one: {
        dataExport: () => `${APIV1}/settings/create/one/dataexport`,
      },
    },
  },
  tradingPartner: {
    create: {
      one: () => `${APIV1}/tradingpartner/create/one`,
      tradingPartnerGlobalLocationNumber: () =>
        `${APIV1}/tradingpartner/create/tradingpartnergloballocationnumber`,
      tradingPartnerAddress: () =>
        `${APIV1}/tradingpartner/create/tradingpartneraddress`,
      tradingPartnerContact: () =>
        `${APIV1}/tradingpartner/create/tradingpartnercontact`,
      tradingPartnerContactDetail: () =>
        `${APIV1}/tradingpartner/create/tradingpartnercontactdetail`,
      tradingPartnerAccountNumber: () =>
        `${APIV1}/tradingpartner/create/tradingpartneraccountnumber`,
    },
    read: {
      one: {
        tradingPartner: {
          by: {
            id: () => `${APIV1}/tradingpartner/read/one/tradingpartner/by/id`,
          },
        },
      },
      many: {
        tradingPartners: {
          search: () =>
            `${APIV1}/tradingpartner/read/many/tradingpartners/search`,
        },
        tradingPartnerContacts: {
          by: {
            outboundDocumentId: () =>
              `${APIV1}/tradingpartner/read/many/tradingpartnercontacts/by/outbounddocumentid`,
          },
        },
      },
      all: {
        attachments: {
          by: {
            tradingPartnerId: () =>
              `${APIV1}/tradingpartner/read/all/attachments/by/tradingpartnerid`,
          },
        },
        by: {
          userId: () =>
            `${APIV1}/tradingpartner/read/all/tradingpartners/by/userid`,
          excludedCustomerLocationId: () =>
            `${APIV1}/tradingpartner/read/all/tradingpartners/by/excludedcustomerlocationid`,
        },
      },
    },
    update: {
      one: {
        tradingPartner: () =>
          `${APIV1}/tradingpartner/update/one/tradingpartner`,
        tradingPartnerGlobalLocationNumber: () =>
          `${APIV1}/tradingpartner/update/one/tradingpartnergloballocationnumber`,
        tradingPartnerAddress: () =>
          `${APIV1}/tradingpartner/update/one/tradingpartneraddress`,
        tradingPartnerContact: () =>
          `${APIV1}/tradingpartner/update/one/tradingpartnercontact`,
        tradingPartnerAccountNumber: () =>
          `${APIV1}/tradingpartner/update/one/tradingpartneraccountnumber`,
      },
    },
    delete: {
      one: {
        attachment: {
          by: {
            id: () => `${APIV1}/tradingpartner/delete/one/attachment/by/id`,
          },
        },
        tradingPartnerGlobalLocationNumber: () =>
          `${APIV1}/tradingpartner/delete/one/tradingpartnergloballocationnumber`,
        tradingPartnerAddress: () =>
          `${APIV1}/tradingpartner/delete/one/tradingpartneraddress`,
        tradingPartnerContact: () =>
          `${APIV1}/tradingpartner/delete/one/tradingpartnercontact`,
        tradingPartnerContactDetail: () =>
          `${APIV1}/tradingpartner/delete/one/tradingpartnercontactdetail`,
        tradingPartnerAccountNumber: () =>
          `${APIV1}/tradingpartner/delete/one/tradingpartneraccountnumber`,
      },
    },
    download: {
      one: {
        attachment: {
          by: {
            id: () => `${APIV1}/tradingpartner/download/one/attachment/by/id`,
          },
        },
      },
    },
    upload: {
      attachment: () => `${APIV1}/tradingpartner/upload/attachment`,
    },
  },
  user: {
    create: {
      emailAddressToken: () => `${APIV1}/user/create/emailaddress/token`,
      one: () => `${APIV1}/user/create/one`,
    },
    read: {
      customer: () => `${APIV1}/user/read/customer`,
      one: {
        by: {
          id: () => `${APIV1}/user/read/one/by/id`,
        },
      },
      all: {
        by: {
          customerId: () => `${APIV1}/user/read/all/by/customerid`,
        },
      },
      other: {
        by: {
          id: () => `${APIV1}/user/read/other/by/id`,
        },
      },
    },
    update: {
      toggleIsActive: () => `${APIV1}/user/update/toggleisactive`,
      otherSettings: () => `${APIV1}/user/update/othersettings`,
      superAdmin: () => `${APIV1}/user/update/superadmin`,
      emailAddress: () => `${APIV1}/user/update/emailaddress`,
    },
    get: {
      isAdmin: {
        by: {
          userId: () => `${APIV1}/user/get/isadmin/by/userid`,
        },
      },
    },
  },
  userCustomerLocation: {
    create: {
      one: () => `${APIV1}/usercustomerlocation/create/one`,
    },
    read: {
      all: {
        by: {
          customerLocationId: () =>
            `${APIV1}/usercustomerlocation/read/all/by/customerlocationid`,
        },
      },
    },
    update: {
      one: {
        toggleAdmin: () =>
          `${APIV1}/usercustomerlocation/update/one/toggleadmin`,
      },
    },
    delete: {
      one: () => `${APIV1}/usercustomerlocation/delete/one`,
    },
  },
  verifiedTradingPartner: {
    read: {
      one: {
        isAs2Active: {
          by: {
            id: () =>
              `${APIV1}/verifiedtradingpartner/read/one/isas2active/by/id`,
          },
        },
      },
    },
  },
  tools: {
    user: {
      read: {
        all: () => `${APIV1}/tools/user/read/all`,
      },
    },
  },
  orderHashMicroservice: {
    read: {
      hashTable: {
        by: {
          userId: () =>
            `${APIV1}/orderhashmicroservice/read/hashtable/by/userId`,
        },
      },
    },
  },
};

export default endpoints;